import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField as TextFieldWrapper,
  styled,
  useMediaQuery,
} from '@mui/material';
import { Modal as ModalWrapper } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import classNames from 'classnames';
import 'dayjs/locale/ru';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { Link, createPath, useLocation, useNavigate } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';
import { useLocalStorageSimple } from '../../hooks/useLocalStorage';

import { Basket } from '../../Modules/Basket';
import { RegisterApi } from '../../api/auth';
import {
  ApiUserType,
  PaymentMethod,
  ReceivingMethod,
} from '../../api/def_common_api';
import { ApiErrorCode } from '../../api/errors';
import Google_Pay_svg from '../../assets/images/basket/Google_Pay.svg';
import MasterCard_svg from '../../assets/images/basket/MasterCard.svg';
import Mir_svg from '../../assets/images/basket/Mir.svg';
import Visa_svg from '../../assets/images/basket/Visa.svg';
import { setLocalStorage } from '../../common/util/localStorage';
import { Util } from '../../common/util/util';
import { CustomButton, Icon } from '../../components';
import { AntSwitch } from '../../components/AntSwitch';
import AuthDialog from '../../components/AuthDialog/AuthDialog';
import { BasketItems } from '../../components/Basket';
import { BasketDialog } from '../../components/BasketDialog';
import { CustomModal } from '../../components/Modal';
import { OurAddress } from '../../components/OutAddress';
import { CheckoutField } from '../../components/TextField/CheckoutField';
import { CheckoutPhoneField } from '../../components/TextField/CheckoutPhoneField';
import CheckoutPhoneOrFullName from '../../components/TextField/CheckoutPhoneOrFullName';
import { useActions } from '../../hooks/useActions';
import { useBasket } from '../../hooks/useBasket';
import { useUser } from '../../hooks/useUser';

import './index.sass';

const CssTextField = styled(TextFieldWrapper)({
  '& label.Mui-focused': {
    color: '#949494',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: '1px solid #D7DDE9',
    },
    '&:hover fieldset': {
      border: '1px solid #D7DDE9',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #D7DDE9',
    },
  },
});
//Оформить заказ
export const Checkout = () => {
  const navigate = useNavigate();
  const {
    setActiveDelivery,
    setAddAddressValue,
    setAddPaymentMethod,
    setBasketCodeVisible,
    setVisibleBasketDialog,
    setWhereDeliveryVisibleTab,
    setDescription,
    setPage,
    setTitleTab,
    setAuthVisible,
    setVisibleDrawerDialog,
    setVisibleOrganization,
  } = useActions();
  const {
    items: basketItems,
    order_sum,
    order_quantity,
    whereDeliveryTab,
    visibleBasketCodeDialog,
    visibleBasketDialog,
    addressValue,
  } = useBasket();
  const {
    visibleOrganization,
    visibleAuthDialog,
    loggedIn,
    isOffline,
    visibleDrawerDialog,
  } = useUser();
  //Способ получения
  const cityPosition = {
    left: {
      city: 'г. Владивосток',
      street: 'ул. Дальзоводская, 4, пав. 310',
      phone: '+7 (423) 246-48-64',
      position: 'left',
    },
    center: {
      city: 'г. Уссурийск',
      street: 'ул. Краснознамённая, 212',
      phone: '+7 (4234) 34-25-16',
      position: 'center',
    },
    right: {
      city: 'г. Находка',
      street: 'ул. Шоссейная, 94в',
      phone: '+7 (4234) 34-25-16',
      position: 'right',
    },
  };
  // Возвращает булевое значение true, если ширина экрана max 900px
  const mobileScreen = useMediaQuery('(max-width:900px)');
  //Загрузка
  const [loading, setLoading] = useState(false);
  //Количество секунд загрузки
  const [counter, setCounter] = useState(2);
  //При получении/Оплата онлайн вкладка
  const [paymentOnDeliveryTab, setPaymentOnDeliveryTab] = useState(
    PaymentMethod.PaymentOnline
  );
  //Показать адрес
  const [showAddress, setShowAddress] = useState(false);
  //Логин
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [main_order_id, setMain_order_id] = useState(0);
  //Выбрать дату доставки. Дефолтное значение - сегодняшнее
  const [deliveryDate, setAddDeliveryDate] = useState<any>(new Date());
  //Окно подсказки что не ввели Email
  const [openAlertEmail, setOpenAlertEmail] = useState(false);
  //Окно подсказки что не ввели Email
  const [openAlertDataError, setOpenAlertDataError] = useState(false);
  //Активная категория города
  const [isActiveDelivery, setIsActiveDelivery] = useState(
    cityPosition.left.position
  );
  // Добавить/Получить организацию
  const [organization, setOrganization] = useLocalStorage(
    'organization_value',
    ''
  );
  const [organizationValue, setOrganizationValue] = useState<any>(organization);
  //Получить токен
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');
  // Добавить/Получить почту
  const [checkoutEmail, setCheckoutEmail] = useLocalStorageSimple('e', '');
  // Добавить/Получить номер телефона
  const [checkoutPhone, setCheckoutPhone] = useLocalStorageSimple('p', '');
  // Добавить/Получить город
  const [cityFromStorage, setСityFromStorage] = useLocalStorage(
    'cityValue',
    cityPosition.left
  );
  // Добавить/Получить физ/юр лицо
  const [physicalTab, setPhysicalTab] = useLocalStorage('physicalTab', true);
  // Добавить/Получить доставку
  const [selfDeliveryTab, setSelfDeliveryTab] = useLocalStorage(
    'selfDeliveryTab',
    true
  );
  // Добавить/Получить адрес
  const [addressValueUser, setAddAddressUser] = useLocalStorage(
    'addAddressUser',
    {
      address: '',
      fullName: '',
      phone: '',
      comment: '',
    }
  );
  //Проверяем, заполнены ли все поля
  const checkAddressValue =
    addressValue.address && addressValue.fullName && addressValue.phone
      ? true
      : false;
  //Данные профиля организации
  const [profileData, setProfileData] = useLocalStorage('saveProfile', '');
  //Я заберу заказ/ Я не заберу заказ
  const [recipientValueFromStorage, setRecipientValueFromStorage] =
    useLocalStorage('other_recipient_value', { fullName: '', phone: '' });
  // Добавить/Получить номер телефона или почту
  const [phone_or_email, setPhoneOrEmail] = useLocalStorageSimple('pe', '');
  //Минимальная разрешенная дата в календаре
  const minDate = moment(new Date());
  let order_sum_text = selfDeliveryTab
    ? `${Util.convertKopecksToRub(order_sum)}`
    : `${Util.convertKopecksToRub(order_sum) + 500}`;
  let order_sum_text_prev = `${Util.convertKopecksToRub(order_sum)}`;
  //Закрыть окно подсказки что не ввели Email
  const handleCloseAlertEmail = () => setOpenAlertEmail(false);
  //Закрыть окно подсказки что не ввели Email
  const handleCloseAlertDateError = () => setOpenAlertDataError(false);
  //Открыть окно "Куда доставить заказ?"
  const handleOpenAddAddressModal = () =>
    setVisibleBasketDialog(!visibleBasketDialog);
  //Физ лицо или юр лицо вкладка
  const onAddPhysicalTab = (tab: any) => {
    setPhysicalTab(tab);
    setPaymentOnDeliveryTab(PaymentMethod.PaymentOnline);
  };
  //Добавить ФИО пользователя
  const onAddFullName = (value: any) =>
    onAddOtherRecipientValue('fullName', value);
  //Добавить телефон получателя пользователя
  const onAddUserPhone = (value: any) =>
    onAddOtherRecipientValue('phone', value);
  //Способ получения - Дата
  const onAddDateValue = (date: any) => setAddDeliveryDate(date);
  //Добавить метод оплаты
  const onAddPaymentMethod = (value: any) => setAddPaymentMethod(value);
  const [openModal, setOpenModal] = useState(false);
  //Куда доставить заказ/Доставка вкладка
  const onVisibleDeliveryTab = (tab: boolean) => {
    if (checkAddressValue) {
      setWhereDeliveryVisibleTab(tab);
    } else {
      setOpenModal(true);
    }
  };
  //Закрыть окно организации
  const handleCloseOrganization = async () => {
    setVisibleOrganization(!visibleOrganization);
  };
  //Показать/закрыть окно адреса
  const handleShowAddress = () => setShowAddress(true);
  //Закрыть адрес
  const handleCloseAddress = () => setShowAddress(false);
  //Открыть окно авторизации
  const handleOpenAuthModal = () => {
    if (mobileScreen) {
      setVisibleDrawerDialog(!visibleDrawerDialog);
    } else {
      setAuthVisible(!visibleAuthDialog);
    }
  };
  //Добавить телефон
  const onAddCheckoutPhone = (phone: string) => setCheckoutPhone(phone);
  //Добавить Email
  const onAddCheckoutEmail = (email: string) => setCheckoutEmail(email);
  //Очищаем Email инпут
  const onRemoveEmailValue = () => setCheckoutEmail('');
  //Открытие модального окна подтверждения кода
  const handleOpen = () => setBasketCodeVisible(!visibleBasketCodeDialog);
  //Закрытие модального окна подтверждения кода
  const handleClose = () => setBasketCodeVisible(!visibleBasketCodeDialog);

  //Самовывоз/Доставка вкладка
  const onAddSelfDeliveryTab = (tab: any) => {
    //Сохраняем в LocalStorage
    setСityFromStorage(cityPosition.left);
    setIsActiveDelivery('left');
    setSelfDeliveryTab(tab);
    if (physicalTab && !tab) {
      setAddPaymentMethod(PaymentMethod.PaymentOnline);
    }
    setPaymentOnDeliveryTab(PaymentMethod.PaymentOnline);
  };

  //Добавить данные пользователя
  const onAddOtherRecipientValue = (name: string, value: any) => {
    const oldValue = {
      ...recipientValueFromStorage,
      [name]: value,
    };
    //Не Я забуру заказ - сохранить состояние в localStorage
    setRecipientValueFromStorage(oldValue);
  };

  //Выбор города
  let add_city_street_phone_value = (position: any) => {
    switch (position) {
      case 'left':
        setСityFromStorage(cityPosition.left);
        break;
      case 'center':
        setСityFromStorage(cityPosition.center);
        break;
      case 'right':
        setСityFromStorage(cityPosition.right);
        break;
    }
  };
  // Активный таб (город)
  const onAddActiveDelivery = (name: string, position: string) => {
    setActiveDelivery(name);
    setIsActiveDelivery(position);
  };

  //Открыть окно организации
  const handleOpenOrganization = () => {
    if (!checkoutEmail) setOpenAlertEmail(true);
    else setVisibleOrganization(!visibleOrganization);
  };
  const [openOffline, setOpenOffline] = useState(false);
  const handleOpenOfflineDialog = () => {
    setOpenOffline(true);
    const timer = setTimeout(() => {
      setOpenOffline(false);
    }, 5000);
    return () => clearTimeout(timer);
  };
  //Отправка формы при нажатии Enter
  const handleUserKeyPress = async (e: any) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      try {
        setPhoneOrEmail(e.target.value);
        const data = await RegisterApi().getRegister(e.target.value);
      } catch (error) {
        console.warn('Register error', error);
      }
    }
  };

  //Подтвердить заказ
  const handleConfirm = async (e?: any) => {
    //Создаем заказ, потом смс-кой подтверждается
    //Создаем заказ
    if (!loggedIn) {
      alert(
        'Вы не авторизованы. Зарегистрируйтесь или авторизуйтесь чтобы оформить заказ'
      );
      return;
    }
    if (physicalTab) {
      //Физ лицо
      if (checkoutPhone === '' || checkoutEmail === '') {
        alert(
          'Вы не ввели Email или Телефон. Введите Email или Телефон чтобы подтвердить заказ'
        );
        return;
      }
      if (checkoutPhone === '' || checkoutPhone == null) {
        alert(
          'Вы не авторизованы. Зарегистрируйтесь или авторизуйтесь чтобы оформить заказ'
        );
        return;
      }
      if (!selfDeliveryTab && whereDeliveryTab && !addressValue.address) {
        alert('Введите адрес доставки');
        return;
      }
      //Если залогирован, то подтверждение по смс для заказа, иначе для авторизации
      if (loggedIn) {
        //Залогирован
        if (checkoutPhone !== '') {
          setLoading(true);
          try {
            //Создаем заказ и ждем смс подтверждения заказа
            const {
              address: delivery_address,
              fullName: other_recipient_name,
              phone: other_recipient_phone,
              comment: delivery_courier_comment,
            } = addressValue;
            let payment_method = paymentOnDeliveryTab;
            let order_info = await Basket.createOrder(
              basketItems,
              selfDeliveryTab ? order_sum : order_sum + 50000,
              checkoutPhone,
              checkoutEmail,
              selfDeliveryTab
                ? ReceivingMethod.SelfDelivery
                : ReceivingMethod.Delivery,
              payment_method,
              physicalTab,
              selfDeliveryTab ? 0 : 50000,
              delivery_address,
              deliveryDate,
              delivery_courier_comment,
              whereDeliveryTab ? false : true,
              whereDeliveryTab ? '' : recipientValueFromStorage.fullName,
              whereDeliveryTab ? '' : recipientValueFromStorage.phone,
              sessionToken
            );

            setMain_order_id(order_info.main_order_id);
            setLocalStorage.saveToLocalStorage(
              'main_order_id',
              order_info.main_order_id
            );

            if (order_info.error_code === ApiErrorCode.no_error) {
              if (PaymentMethod.PaymentOnline === payment_method) {
                if (document.readyState === 'complete') {
                  setLoading(true);
                }
                // @ts-ignore
                window.location = order_info.pay_url;
              }
              if (
                PaymentMethod.PaymentOnDelivery === payment_method ||
                PaymentMethod.BankTransfer === payment_method
              ) {
                navigate('/order-info', {
                  state: { main_order_id: order_info.main_order_id },
                });
              }
            } else {
              alert(order_info.message);
            }
          } catch (e) {
            if (isOffline) {
              handleOpenOfflineDialog();
            }
            setLoading(false);
            console.warn(e);
          } finally {
            setLoading(false);
          }
        }
      } else {
        //Не залогирован
        //Логируемся с одноразовым временным паролем по sms, а потом показываем окно с подтверждением по sms для авторизации
        //После этого создаем заказ и переводим юзера на оплату
        //Теперь показываем окно для ввода кода подтверждения
        getPwdWithOneTimePassword(checkoutPhone);
      }
    } else {
      //Юр лицо, ИП
      if (checkoutPhone === '' || checkoutEmail === '') {
        alert(
          'Вы не ввели Email или Телефон. Введите Email или Телефон чтобы подтвердить заказ'
        );
        return;
      }
      if (checkoutPhone === '' || checkoutPhone == null) {
        alert(
          'Вы не авторизованы. Зарегистрируйтесь или авторизуйтесь чтобы оформить заказ'
        );
        return;
      }
      if (!selfDeliveryTab && whereDeliveryTab && !addressValue.address) {
        alert('Введите адрес доставки');
        return;
      }
      if (loggedIn && checkoutPhone !== '' && checkoutEmail !== '') {
        //Залогирован
        //Создаем заказ
        setLoading(true);
        //У юр.лица телефон и email берем из redux, т.к. он уже залогинен
        try {
          const {
            address: delivery_address,
            fullName: other_recipient_name,
            phone: other_recipient_phone,
            comment: delivery_courier_comment,
          } = addressValue;
          let payment_method = paymentOnDeliveryTab;
          let order_info = await Basket.createOrder(
            basketItems,
            selfDeliveryTab ? order_sum : order_sum + 50000,
            checkoutPhone,
            checkoutEmail,
            selfDeliveryTab
              ? ReceivingMethod.SelfDelivery
              : ReceivingMethod.Delivery,
            payment_method,
            physicalTab,
            selfDeliveryTab ? 0 : 50000, //Елси самовывоз, то доставка 0, иначе 500
            delivery_address,
            deliveryDate,
            whereDeliveryTab ? delivery_courier_comment : '',
            !whereDeliveryTab,
            whereDeliveryTab ? '' : recipientValueFromStorage.fullName,
            whereDeliveryTab ? '' : recipientValueFromStorage.phone,
            sessionToken
          );

          if (
            order_info.error_code ===
            ApiErrorCode.catalog_item_is_not_available_or_no_availability_count
          ) {
            if (order_info) {
              // @ts-ignore
              alert(order_info.message);
            }
            return;
          }
          setLocalStorage.saveToLocalStorage(
            'main_order_id',
            order_info.main_order_id
          );
          setMain_order_id(order_info.main_order_id);
          if (order_info.error_code === ApiErrorCode.no_error) {
            if (PaymentMethod.PaymentOnline === payment_method) {
              if (document.readyState === 'complete') {
                setLoading(true);
              }
              // @ts-ignore
              window.location = order_info.pay_url;
            }
            if (
              PaymentMethod.PaymentOnDelivery === payment_method ||
              PaymentMethod.BankTransfer === payment_method
            ) {
              navigate('/order-info', {
                state: { main_order_id: order_info.main_order_id },
              });
            }
          } else if (order_info.error_code === ApiErrorCode.inn_not_found) {
            //Временный alert (пока дизайна нет):
            alert('ИНН не установлен. Зарегистрируйтесь как юр.лицо');
            setLoading(false);
            return;
          } else {
            alert(order_info.message);
          }
        } catch (e) {
          if (isOffline) {
            handleOpenOfflineDialog();
          }
          setLoading(false);
          console.warn(e);
        } finally {
          setLoading(false);
        }
      }
    }
  };
  //Получить пароль(код)
  //Регистрация пользователя c временным одноразовым паролем
  const getPwdWithOneTimePassword = (phone_or_email: string) => {
    const getData = async () => {
      const dataResponce = await axios({
        method: 'post',
        url: '/api/admin/users',
        baseURL: process.env.REACT_APP_BASE_URL_API,
        headers: {
          token: Util.getTokenSecurity(),
        },
        data: {
          phone_or_email: phone_or_email,
          action: 'register_user_with_temp_pwd',
        },
      });
      if (!dataResponce.data.error) {
        //Теперь показываем окно для ввода кода подтверждения авторизации
        setShowLoginModal(true);
        setBasketCodeVisible(true);
      }
    };
    getData();
  };
  //Получить профиль пользователя
  const getProfileData = async () => {
    const dataResponce = await axios({
      method: 'get',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/user-profile',
      headers: {
        'session-token': sessionToken,
      },
    });

    if (!dataResponce.data.error) {
      setProfileData(dataResponce.data.profile);
    }
    return dataResponce.data.profile;
  };

  //Сохранить профиль
  const saveProfileData = async (profile: any) => {
    const dataResponse = await axios({
      method: 'patch',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/user-profile',
      headers: {
        'session-token': sessionToken,
      },
      data: profile,
    });

    if (!dataResponse.data.error) {
    }
  };
  //Подтверждение удаления организации
  const onConfirmRemove = async () => {
    //Получить АКТУАЛЬНЫЙ профиль пользователя
    let profile = await getProfileData();

    if (profile != null) {
      //Записать профиль
      //Удаляем организацию путем выставления типа пользователя в физ.лицо
      const oldProfile = {
        ...profile,
        type: ApiUserType.physical_person,
        inn: '',
        kpp: '',
        org_name: '',
        org_name_print: '',
        legal_address: '',
        mailing_address: '',
      };
      await saveProfileData(oldProfile);
      //Теперь считываем профиль для обновления представления
      await getProfileData();
    }
    //Очищаем состояние в localstorage
    setOrganizationValue('');
    setOrganization('');
  };

  useEffect(() => {
    //Заголовок страницы
    setTitleTab('Dazel.ru - Оформление заказа');
    //Описание страницы
    setDescription('');
    setPage('basket');
    if (document.readyState === 'interactive') {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 0);
    }
    setAddAddressValue(addressValueUser);
    //Таймер лоадера
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    // @ts-ignore
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    //Получить профиль пользователя
    getProfileData();
  }, [sessionToken]);
  return (
    <div className="main">
      <div className="catalog__wrapper">
        <>
          <div className="Checkout">
            <section className="header__middle__bottom_desktop">
              <h1>Оформление заказа</h1>
              <div className="header__middle__bottom_back_desktop">
                <Icon variant="closeBackOrange" />
                <Link to="/">Вернуться к покупкам</Link>
              </div>
            </section>
            {order_quantity ? (
              <div className="Checkout_div">
                {/*Левая часть(Контактная информация)*/}
                <div className="Checkout_div_left">
                  {/*Контактная информация*/}
                  <div
                    className={classNames('Checkout_div_left_part1', {
                      loggedIn: !loggedIn,
                    })}
                  >
                    <div
                      className={classNames('Checkout_div_left_part1_contact', {
                        entity: !physicalTab,
                        loggedIn: !loggedIn,
                      })}
                    >
                      <div className="Checkout_div_left_part1_contact_left">
                        <span className="Checkout_div_left_part1_contact_caption">
                          Контактная информация
                        </span>
                        {/*Физ лицо*/}
                        {visibleBasketCodeDialog && (
                          <AuthDialog
                            window="modal"
                            handleClose={handleClose}
                            handleOpen={handleOpen}
                            defaultType="code"
                            open={visibleBasketCodeDialog}
                            basketCode
                          />
                        )}
                        {loggedIn && (
                          <div className="Checkout_div_left_part1_contact_tabs">
                            <div
                              className={
                                physicalTab
                                  ? 'Checkout_dazel-tab-active'
                                  : 'Checkout_dazel-tab physical'
                              }
                              onClick={() => onAddPhysicalTab(true)}
                            >
                              <span>Физическое лицо</span>
                            </div>
                            <AntSwitch
                              onAddTab={onAddPhysicalTab}
                              tab={physicalTab}
                            />
                            <div
                              className={
                                physicalTab
                                  ? 'Checkout_dazel-tab'
                                  : 'Checkout_dazel-tab-active '
                              }
                              onClick={() => onAddPhysicalTab(false)}
                            >
                              <span>Юридическое лицо</span>
                            </div>
                          </div>
                        )}

                        {/*Юр лицо*/}
                      </div>

                      {loggedIn && (
                        <div className="Checkout_div_left_part1_contact_physical">
                          <div className="Checkout_div_left_part1_contact_physical__wrapper">
                            <CheckoutPhoneField
                              onChangeValue={onAddCheckoutPhone}
                              value={checkoutPhone}
                              name="phone"
                              label="Номер телефона"
                              required
                            />
                            <div className="Checkout_div_left_part1_contact_physical_email">
                              <CheckoutField
                                onChangeValue={onAddCheckoutEmail}
                                value={checkoutEmail}
                                name="email"
                                label="Email"
                                required
                              />
                              {checkoutEmail && (
                                <Icon
                                  variant="closeGray"
                                  className="modal-input__organization_icon active"
                                  onClick={onRemoveEmailValue}
                                />
                              )}
                            </div>
                          </div>

                          {!organizationValue.value && !physicalTab && (
                            <Button
                              onClick={handleOpenOrganization}
                              variant="text"
                              startIcon={<Icon variant="plusOrange" />}
                              className="Checkout_div_left_part1_contact_btn"
                              sx={{
                                borderRadius: '8px',
                                color: '#FC5808',
                                fontSize: '14px',
                                fontWeight: '500',
                                textTransform: 'none',
                                '&.MuiButton-root:hover': {
                                  borderRadius: '8px',
                                  color: '#FF9F2F',
                                  fontSize: '14px',
                                  fontWeight: '500',
                                  textTransform: 'none',
                                  backgroundColor: '#fff',
                                },
                              }}
                            >
                              <p>Добавить организацию</p>
                            </Button>
                          )}

                          {organizationValue.value && !physicalTab && (
                            <div className="modal-input__organization active">
                              <CheckoutField
                                value={
                                  organizationValue.data.org_name
                                    ? organizationValue?.data.org_name
                                    : organizationValue?.data.name
                                        ?.short_with_opf
                                }
                                sx={{ background: '#F6F8FB' }}
                                name="org"
                                label="Организация"
                              />
                              <Icon
                                variant="closeGray"
                                className="modal-input__organization_icon active"
                                onClick={onConfirmRemove}
                              />
                            </div>
                          )}

                          {visibleOrganization && (
                            <div className="modal">
                              <ModalWrapper
                                keepMounted
                                onClose={handleCloseOrganization}
                                // @ts-ignore
                                open={visibleOrganization}
                                aria-labelledby="keep-mounted-modal-title"
                                aria-describedby="keep-mounted-modal-description"
                              >
                                {/* <UdateOrg />*/}
                                <></>
                              </ModalWrapper>
                            </div>
                          )}
                          {
                            <Dialog
                              open={openAlertEmail}
                              onClose={handleCloseAlertEmail}
                              aria-labelledby="alert-dialog-title"
                              aria-describedby="alert-dialog-description"
                            >
                              <DialogTitle id="alert-dialog-title">
                                {'Введите email для добавления организации'}
                              </DialogTitle>

                              <DialogActions>
                                <Button
                                  onClick={handleCloseAlertEmail}
                                  autoFocus
                                >
                                  Хорошо
                                </Button>
                              </DialogActions>
                            </Dialog>
                          }
                        </div>
                      )}

                      {!loggedIn && (
                        <div className="Checkout_login contacts">
                          <span onClick={handleOpenAuthModal}>
                            Войти или зарегистрироваться
                          </span>
                          , чтобы оформить заказ
                        </div>
                      )}
                    </div>
                  </div>

                  {/*Способ получения*/}
                  <div className="Checkout_div_left_part2">
                    <div
                      className={classNames('Checkout_div_left_part2_wrap', {
                        self_devilery: selfDeliveryTab,
                        self_devilery_address:
                          addressValue.address ||
                          addressValue.phone ||
                          addressValue.fullName,
                        entity: !physicalTab,
                        loggedIn: !loggedIn,
                      })}
                    >
                      <div className="Checkout_div_left_part2_delivery">
                        <div className="Checkout_div_left_part2_delivery_top">
                          <span className="Checkout_div_left_part2_delivery_caption">
                            Способ получения
                          </span>
                          {loggedIn && (
                            <div className="Checkout_div_left_part2_delivery_tabs">
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <div
                                  className={
                                    selfDeliveryTab
                                      ? 'Checkout_dazel-tab-active'
                                      : 'Checkout_dazel-tab self_delivery'
                                  }
                                  onClick={() => onAddSelfDeliveryTab(true)}
                                >
                                  Самовывоз
                                </div>
                                <AntSwitch
                                  onAddTab={onAddSelfDeliveryTab}
                                  tab={selfDeliveryTab}
                                />
                                <div
                                  className={
                                    selfDeliveryTab
                                      ? 'Checkout_dazel-tab delivery'
                                      : 'Checkout_dazel-tab-active'
                                  }
                                  onClick={() => onAddSelfDeliveryTab(false)}
                                >
                                  Доставка
                                </div>
                              </Stack>
                            </div>
                          )}
                        </div>
                        {loggedIn && (
                          <div className="Checkout_div_left_part2_delivery_center">
                            <button
                              onClick={() => {
                                onAddActiveDelivery('г. Владивосток', 'left');
                                add_city_street_phone_value('left');
                              }}
                              className={classNames(
                                'Checkout_div_left_part2_delivery_center_btn',
                                { active: isActiveDelivery === 'left' }
                              )}
                            >
                              г. Владивосток
                            </button>
                            {selfDeliveryTab && (
                              <>
                                <button
                                  onClick={() => {
                                    onAddActiveDelivery(
                                      'г. Уссурийск',
                                      'center'
                                    );
                                    add_city_street_phone_value('center');
                                  }}
                                  className={classNames(
                                    'Checkout_div_left_part2_delivery_center_btn',
                                    {
                                      active: isActiveDelivery === 'center',
                                    }
                                  )}
                                >
                                  г. Уссурийск
                                </button>
                                <button
                                  onClick={() => {
                                    onAddActiveDelivery(
                                      'г. Уссурийск',
                                      'right'
                                    );
                                    add_city_street_phone_value('right');
                                  }}
                                  className={classNames(
                                    'Checkout_div_left_part2_delivery_center_btn',
                                    {
                                      active: isActiveDelivery === 'right',
                                    }
                                  )}
                                >
                                  г. Находка
                                </button>
                              </>
                            )}
                          </div>
                        )}
                        {/*Самовывоз*/}
                        {loggedIn && selfDeliveryTab && (
                          <div className="Checkout_div_left_part2_delivery_self">
                            <div className="Checkout_div_left_part2_delivery_self_left">
                              <span className="Checkout_div_left_part2_delivery_self_caption">
                                {isActiveDelivery === 'left' &&
                                  'DAZEL “Технариум”'}
                                {isActiveDelivery === 'center' &&
                                  'Торговый центр'}
                                {isActiveDelivery === 'right' &&
                                  'Склад "DAZEL"'}
                              </span>
                              <span
                                className={classNames(
                                  'Checkout_div_left_part2_delivery_self_span2',
                                  {
                                    center: isActiveDelivery === 'center',
                                    right: isActiveDelivery === 'right',
                                  }
                                )}
                                onClick={handleShowAddress}
                              >
                                <Icon variant="mapGray" />
                                <p>
                                  {isActiveDelivery === 'left' && (
                                    <span>ул. Дальзоводская, 4, пав. 310</span>
                                  )}
                                  {isActiveDelivery === 'center' && (
                                    <span>ул. Краснознамённая, 212</span>
                                  )}
                                  {isActiveDelivery === 'right' && (
                                    <span>ул. Шоссейная, 94в</span>
                                  )}
                                </p>
                              </span>
                              <span className="Checkout_div_left_part2_delivery_self_span3">
                                <Icon variant="phoneGray" />
                                {isActiveDelivery === 'left' && (
                                  <span>+7 (423) 246-48-64</span>
                                )}
                                {isActiveDelivery === 'center' && (
                                  <span>+7 (4234) 34-25-16</span>
                                )}
                                {isActiveDelivery === 'right' && (
                                  <span>+7 (4236) 69-86-75</span>
                                )}
                              </span>
                            </div>
                            <div className="Checkout_div_left_part2_delivery_self_right">
                              <div>Пн-Пт с 9:00 до 18:00</div>
                              <div>Сб с 9:00 до 15:00</div>
                            </div>
                          </div>
                        )}
                        {loggedIn && showAddress && (
                          <>
                            {isActiveDelivery === 'left' && (
                              <OurAddress
                                open={showAddress}
                                handleClose={handleCloseAddress}
                                address="ул. Дальзоводская, 4, пав. 310"
                              >
                                <iframe
                                  src="https://yandex.ru/map-widget/v1/?um=constructor%3A685160ebcbd08cdd6fced4352a2da0677b7dad84ab9f5e22966bb3ba8af08660&amp;source=constructor"
                                  width="100%"
                                  height="500"
                                  frameBorder="0"
                                ></iframe>
                              </OurAddress>
                            )}
                            {isActiveDelivery === 'center' && (
                              <OurAddress
                                open={showAddress}
                                handleClose={handleCloseAddress}
                                address="ул. Краснознамённая, 212"
                              >
                                <iframe
                                  src="https://yandex.ru/map-widget/v1/?um=constructor%3A9d2ca837684c3f7789adc75e9cfee5851f860a203c87a4fe287051a3b4c2e22e&amp;source=constructor"
                                  width="100%"
                                  height="500"
                                  frameBorder="0"
                                ></iframe>
                              </OurAddress>
                            )}
                            {isActiveDelivery === 'right' && (
                              <OurAddress
                                open={showAddress}
                                handleClose={handleCloseAddress}
                                address="ул. Шоссейная, 94в"
                              >
                                <iframe
                                  src="https://yandex.ru/map-widget/v1/?um=constructor%3Af9ea78b3fa2dcef52858cc08eb77c350c45f8303faf4f4e16c8e390f75da1b63&amp;source=constructor"
                                  width="100%"
                                  height="500"
                                  frameBorder="0"
                                ></iframe>
                              </OurAddress>
                            )}
                          </>
                        )}
                        {/*Доставка*/}
                        {loggedIn && !selfDeliveryTab && (
                          <div className="Checkout_div_left_part2_delivery_deliv">
                            <div className="Checkout_div_left_part2_delivery_deliv_top">
                              <span className="Checkout_div_left_part2_delivery_self_caption">
                                Куда доставить заказ?
                              </span>
                              <div className="Checkout_div_left_part2_delivery_deliv_top">
                                <div className="BasketPage_div_left_service_check_group">
                                  <input
                                    id="basket_check_1"
                                    checked={whereDeliveryTab}
                                    className="inp-cbx"
                                    style={{ display: 'none' }}
                                    type="checkbox"
                                    onClick={(e: any) => {
                                      onVisibleDeliveryTab(e.target.checked);
                                    }}
                                    defaultChecked={true}
                                  />
                                  <label
                                    className="cbx"
                                    htmlFor="basket_check_1"
                                  >
                                    <span>
                                      <svg
                                        width="11px"
                                        height="8px"
                                        viewBox="0 0 12 10"
                                      >
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                      </svg>
                                    </span>
                                    <span>Я заберу заказ</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="Checkout_div_left_part2_delivery_deliv_group">
                              <div className="Checkout_div_left_part2_delivery_deliv_group1">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                  locale="ru"
                                >
                                  <DesktopDatePicker
                                    value={deliveryDate}
                                    minDate={minDate}
                                    inputFormat="DD.MM.YYYY"
                                    onChange={(newValue: any) => {
                                      onAddDateValue(newValue);
                                    }}
                                    renderInput={(params) => (
                                      <CssTextField
                                        {...params}
                                        className="Checkout_div_left_part1_contact__inp_date"
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                                <div className="Checkout_div_left_part2_delivery_deliv_group1_right">
                                  <Icon variant="timeGray" />
                                  <p>Время доставки с 9:00 до 18:00</p>
                                </div>
                              </div>
                              <div className="Checkout_div_left_part2_delivery_deliv_group2">
                                {whereDeliveryTab ? (
                                  <Fragment>
                                    {whereDeliveryTab &&
                                    addressValue.address &&
                                    addressValue.phone &&
                                    addressValue.fullName ? (
                                      <div className="Checkout_div_left_part2_delivery_deliv_group2_add-address_wrapper">
                                        <div className="Checkout_div_left_part2_delivery_deliv_group2_add-address_item">
                                          <Icon variant="mapGray" />
                                          <p
                                            className="Checkout_div_left_part2_delivery_deliv_group2_add-address_text text_1"
                                            onClick={handleOpenAddAddressModal}
                                          >
                                            {addressValue.address}
                                          </p>
                                        </div>
                                        <div className="Checkout_div_left_part2_delivery_deliv_group2_add-address_item">
                                          <Icon variant="nameOrPhone" />
                                          <p
                                            className="Checkout_div_left_part2_delivery_deliv_group2_add-address_text text_2"
                                            onClick={handleOpenAddAddressModal}
                                          >{`${addressValue.fullName}, ${addressValue.phone}`}</p>
                                        </div>
                                      </div>
                                    ) : (
                                      <Button
                                        onClick={handleOpenAddAddressModal}
                                        variant="text"
                                        startIcon={
                                          <Icon variant="plusOrange" />
                                        }
                                        className="Checkout_div_left_part1_contact_btn add-address"
                                        sx={{
                                          borderRadius: '8px',
                                          color: '#FC5808',
                                          fontSize: '14px',
                                          fontWeight: '500',
                                          textTransform: 'none',
                                          '&.MuiButton-root:hover': {
                                            borderRadius: '8px',
                                            color: '#FF9F2F',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            textTransform: 'none',
                                            backgroundColor: '#fff',
                                          },
                                        }}
                                      >
                                        <p>Добавить адрес доставки</p>
                                      </Button>
                                    )}
                                  </Fragment>
                                ) : (
                                  <div className="Checkout_div_left_part2_delivery_deliv_group2_inp">
                                    <CheckoutPhoneOrFullName
                                      onChange={onAddFullName}
                                      value={recipientValueFromStorage.fullName}
                                      name="fullName"
                                      label="ФИО получателя"
                                    />
                                    <CheckoutPhoneOrFullName
                                      onChange={onAddUserPhone}
                                      value={recipientValueFromStorage.phone}
                                      name="phone"
                                      label="Телефон получателя"
                                    />
                                  </div>
                                )}
                              </div>
                              <BasketDialog />
                              {addressValue.address &&
                                addressValue.phone &&
                                addressValue.fullName && (
                                  <p className="Checkout_div_left_part2_delivery_deliv_group_bottom">
                                    При себе иметь наложенный документ
                                    удостоверяющий личность или физическое
                                    наличие банковской карты
                                  </p>
                                )}
                            </div>
                          </div>
                        )}
                        {!loggedIn && (
                          <div className="Checkout_login">
                            <span onClick={handleOpenAuthModal}>
                              Войти или зарегистрироваться
                            </span>
                            , чтобы выбрать способ получения
                          </div>
                        )}
                      </div>
                    </div>
                    {/*Способ оплаты*/}
                    <div
                      className={classNames('Checkout_div_left_part3', {
                        active: !selfDeliveryTab && !physicalTab,
                        login: !loggedIn,
                        radio_active: !selfDeliveryTab && physicalTab,
                        entity: physicalTab && !selfDeliveryTab,
                      })}
                    >
                      <div
                        className={classNames('Checkout_div_left_part3_pay', {
                          active: !selfDeliveryTab && !physicalTab,
                          login: !loggedIn,
                          entity: physicalTab && !selfDeliveryTab,
                          loggedIn: !loggedIn,
                        })}
                      >
                        <span className="Checkout_div_left_part3_pay_caption">
                          Способ оплаты
                        </span>
                        {loggedIn ? (
                          <Fragment>
                            <FormControl>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue={
                                  selfDeliveryTab
                                    ? 'payment_online'
                                    : 'payment_online'
                                }
                                name="radio-buttons-group"
                                onChange={(event: any, index) => {
                                  onAddPaymentMethod(event.target.value);
                                  setPaymentOnDeliveryTab(event.target.value);
                                }}
                                value={paymentOnDeliveryTab}
                                // @ts-ignore
                              >
                                {physicalTab ? (
                                  <>
                                    {!selfDeliveryTab && (
                                      <FormControlLabel
                                        checked={
                                          paymentOnDeliveryTab ===
                                          PaymentMethod.PaymentOnline
                                        }
                                        defaultValue="payment_online"
                                        value="payment_online"
                                        className={
                                          paymentOnDeliveryTab ===
                                          PaymentMethod.PaymentOnline
                                            ? 'Checkout_div_left_part3_pay_radio active payment_online'
                                            : 'Checkout_div_left_part3_pay_radio '
                                        }
                                        control={
                                          <Radio
                                            sx={{
                                              color: '#D7DDE9',
                                            }}
                                          />
                                        }
                                        label="Банковской картой на сайте"
                                      />
                                    )}
                                    {selfDeliveryTab && (
                                      <>
                                        {selfDeliveryTab && (
                                          <FormControlLabel
                                            checked={
                                              paymentOnDeliveryTab ===
                                              PaymentMethod.PaymentOnline
                                            }
                                            value="payment_online"
                                            className={
                                              paymentOnDeliveryTab ===
                                              PaymentMethod.PaymentOnline
                                                ? 'Checkout_div_left_part3_pay_radio active payment_online'
                                                : 'Checkout_div_left_part3_pay_radio'
                                            }
                                            control={
                                              <Radio
                                                sx={{
                                                  color: '#D7DDE9',
                                                }}
                                              />
                                            }
                                            label="Банковской картой на сайте"
                                          />
                                        )}
                                        <FormControlLabel
                                          checked={
                                            paymentOnDeliveryTab ===
                                            PaymentMethod.BankTransfer
                                          }
                                          value="bank_transfer"
                                          className={
                                            paymentOnDeliveryTab ===
                                            PaymentMethod.BankTransfer
                                              ? 'Checkout_div_left_part3_pay_radio active bank_transfer'
                                              : 'Checkout_div_left_part3_pay_radio'
                                          }
                                          control={
                                            <Radio
                                              sx={{
                                                color: '#D7DDE9',
                                              }}
                                            />
                                          }
                                          label="Банковской картой при получении товара"
                                        />
                                        <FormControlLabel
                                          checked={
                                            paymentOnDeliveryTab ===
                                            PaymentMethod.PaymentOnDelivery
                                          }
                                          value="payment_on_delivery"
                                          className={
                                            paymentOnDeliveryTab ===
                                            PaymentMethod.PaymentOnDelivery
                                              ? 'Checkout_div_left_part3_pay_radio active payment_on_delivery'
                                              : 'Checkout_div_left_part3_pay_radio'
                                          }
                                          control={
                                            <Radio
                                              sx={{
                                                color: '#D7DDE9',
                                              }}
                                            />
                                          }
                                          label="Наличными при получении товара"
                                        />
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <FormControlLabel
                                      checked={
                                        paymentOnDeliveryTab ===
                                        PaymentMethod.PaymentOnline
                                      }
                                      value="payment_online"
                                      className={
                                        paymentOnDeliveryTab ===
                                        PaymentMethod.PaymentOnline
                                          ? 'Checkout_div_left_part3_pay_radio active payment_online'
                                          : 'Checkout_div_left_part3_pay_radio'
                                      }
                                      control={
                                        <Radio
                                          sx={{
                                            color: '#D7DDE9',
                                          }}
                                        />
                                      }
                                      label="Банковской картой на сайте"
                                    />

                                    <FormControlLabel
                                      checked={
                                        paymentOnDeliveryTab ===
                                        PaymentMethod.BankTransfer
                                      }
                                      value="bank_transfer"
                                      className={
                                        paymentOnDeliveryTab ===
                                        PaymentMethod.BankTransfer
                                          ? 'Checkout_div_left_part3_pay_radio active payment_online'
                                          : 'Checkout_div_left_part3_pay_radio'
                                      }
                                      control={
                                        <Radio
                                          sx={{
                                            color: '#D7DDE9',
                                          }}
                                        />
                                      }
                                      label="Оплата на расчетный счет"
                                    />
                                  </>
                                )}
                              </RadioGroup>
                            </FormControl>
                            {/*Оплата онлайн*/}
                            <div className="Checkout_div_left_part3_pay_online">
                              <img src={Visa_svg} />
                              <img src={MasterCard_svg} />
                              <img src={Mir_svg} />
                              <img src={Google_Pay_svg} />
                            </div>
                          </Fragment>
                        ) : (
                          <div className="Checkout_login">
                            <span onClick={handleOpenAuthModal}>
                              Войти или зарегистрироваться
                            </span>
                            , чтобы выбрать способ оплаты
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/*Корзина */}
                  <BasketItems />
                </div>
                {/*Правая часть(Итого)*/}
                <div className="Checkout_div_right">
                  <div className="Checkout_div_right_itog">
                    <h2>Ваш заказ</h2>
                    <div className="Checkout_div_right_itog_line2">
                      <span
                        className={classNames(
                          'Checkout_div_right_itog_line2_span1',
                          // Немного костыль
                          {
                            custom: order_quantity >= 10, // Если равен 1 символу(цифре), то меняем ширину
                          }
                        )}
                      >
                        Товары ({order_quantity})
                      </span>
                      <div className="Checkout_div_right_itog_line2_span2" />
                      <span
                        className={classNames(
                          'Checkout_div_right_itog_line2_span3',
                          // Немного костыль
                          {
                            one: order_sum_text_prev.length < 2,
                            two: order_sum_text_prev.length === 2,
                            three: order_sum_text_prev.length === 3,
                            four: order_sum_text_prev.length === 4,
                            five: order_sum_text_prev.length === 5,
                            six: order_sum_text_prev.length >= 6,
                            nine: order_sum_text_prev.length >= 8,
                          }
                        )}
                      >
                        {`${Util.convertKopecksToRub(order_sum)}`}
                      </span>
                      <span className="Checkout_div_right_itog_line2_span4_currency">
                        ₽
                      </span>
                    </div>
                    <div className="Checkout_div_right_itog_line2">
                      <span className="Checkout_div_right_itog_line2_span1 devel">
                        Стоимость доставки
                      </span>
                      <div className="Checkout_div_right_itog_line2_span2 " />
                      <div>
                        <span
                          className={
                            selfDeliveryTab
                              ? 'Checkout_div_right_itog_line2_span3 devel'
                              : 'Checkout_div_right_itog_line2_span3 devel tab'
                          }
                        >
                          {selfDeliveryTab ? '0' : '500'}
                        </span>
                        <span className="Checkout_div_right_itog_line2_span4_currency">
                          ₽
                        </span>
                      </div>
                    </div>
                    <div className="Checkout_div_right_itog_line2">
                      <span className="Checkout_div_right_itog_line2_span1 total">
                        Итого
                      </span>
                      <div className="Checkout_div_right_itog_line2_span2" />
                      <div>
                        <span
                          className={classNames(
                            'Checkout_div_right_itog_line3_span3 total',
                            // Немного костыль
                            {
                              one: order_sum_text.length < 2,
                              two: order_sum_text.length === 2, // Если равен 1 символу(цифре), то меняем ширину
                              three: order_sum_text.length === 3,
                              four: order_sum_text.length === 4,
                              five: order_sum_text.length === 5,
                              six: order_sum_text.length >= 6,
                              nine: order_sum_text.length >= 8,
                            }
                          )}
                        >
                          {selfDeliveryTab
                            ? `${order_sum / 100}`
                            : `${order_sum / 100 + 500}`}
                        </span>
                        <span className="Checkout_div_right_itog_line3_span3_currency">
                          ₽
                        </span>
                      </div>
                    </div>
                    <Button
                      type="submit"
                      variant="orange"
                      color="primary"
                      fullWidth
                      onClick={handleConfirm}
                    >
                      Подтвердить заказ
                    </Button>
                    {counter && loading ? (
                      <Backdrop
                        sx={{
                          color: '#fff',
                          zIndex: (theme) => theme.zIndex.drawer + 1,
                        }}
                        open={loading}
                      >
                        <CircularProgress color="inherit" />
                      </Backdrop>
                    ) : (
                      <></>
                    )}
                    <span className="Checkout_div_right_delivery">
                      Подтверждая заказ, Вы соглашаетесь с
                      <span>
                        условиями политики конфиденциальности и правилами
                        продажи
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="Checkout_empty">
                <h2 className="Checkout_empty_title">Корзина пуста</h2>
                <p className="Checkout_empty_text">
                  Загляните на главную, чтобы выбрать товары или найдите нужное
                  в поиске
                </p>
                <Link to="/">
                  <CustomButton variant="blue" className="empty_home">
                    Перейти на главную
                  </CustomButton>
                </Link>
              </div>
            )}
            <CustomModal
              onClick={() => setOpenModal(false)}
              open={openModal}
              onClose={() => setOpenModal(false)}
            >
              <div style={{ fontSize: '12px' }}>Добавьте адрес доставки</div>
            </CustomModal>
            <CustomModal
              onClick={() => setOpenOffline(false)}
              open={openOffline}
              onClose={() => setOpenOffline(false)}
            >
              <div style={{ fontSize: '12px' }}>
                Произошла ошибка. Проверьте подключение к сети и повторите
                попытку
              </div>
            </CustomModal>
          </div>
          {/*<Dialog
            open={openAlertDataError}
            onClose={handleCloseAlertDateError}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {'Вы ввели неверные данные карты.       Подтвердите заказ повторно и введите данные правильно.'}
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCloseAlertDateError} autoFocus>
                Закрыть
              </Button>
            </DialogActions>
          </Dialog>*/}
          {/*          <div className="modal">
            <Modal
              open={openModal}
              onClose={() => setOpenModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modal__wrapper">
                <Box className="modal-top">
                  <CloseRoundedIcon className="modal__img" color="disabled" onClick={handleClose} />
                  <Box>
                    Добавьте <b>адрес доставки</b>
                  </Box>
                </Box>
              </Box>
            </Modal>
          </div>*/}
          {/*          <CustomModal onClick={() => setOpenModal(false)} open={openModal} onClose={() => setOpenModal(false)}>
            <div style={{ fontSize: '12px' }}>
              Добавьте <b>адрес доставки</b>
            </div>
          </CustomModal>*/}
        </>
      </div>
    </div>
  );
};
